module.exports = __webpack_public_path__ + "media/images/icon_local-eade3ebeb7ac50f798cd40ed5fe62232.png";